import React from 'react';
import { PluginType, type IExportPlugin } from '@/version-types';
import { useFramework } from '../../hooks';
import { useEscapeDeselectHotkey } from './use-escape-deselect';
import { useKeyboardMouseSync } from './use-keyboard-mouse-sync';
import { useRedoUndoHotkey } from './use-redo-undo-hotkey';
import { useSaveHotkey } from './use-save-hotkey';
import { useScaleHotkey } from './use-scale-hotkey';
import { useSelectAllHotkey } from './use-select-all-hotkey';
import { useShowAllHotkey } from './use-show-all-hotkey';

/**
 * 画布/编辑器级快捷键（子逻辑见 `use-*-hotkey.ts` / `use-keyboard-mouse-sync.ts`）。
 * 文本图层 T 键见 `textLayerHotkeyPlugin`（`@/layers/text-layer/plugins`）。
 */
const FrameworkHotkeyView: React.FC = React.memo(() => {
    const framework = useFramework();

    useKeyboardMouseSync(framework);
    useEscapeDeselectHotkey(framework);
    useSaveHotkey(framework);
    useRedoUndoHotkey(framework);
    useScaleHotkey(framework);
    useSelectAllHotkey(framework);
    useShowAllHotkey(framework);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'framework-hotkey',
    render() {
        return <FrameworkHotkeyView />;
    },
};

export default exportPlugin;
